export default __webpack_public_path__ + "static/media/ban-mobile-image-5.f84770f8.jpg";